import { queryKeyFilters } from 'constants/url'
import { isEmpty } from 'lib/array/arrayUtils'
import { slugify } from 'lib/string/stringUtils'

export default function isAnyFilterApplied(params: Record<string, any> = {}): boolean {
  return !isEmpty(params) && queryKeyFilters.some(filterKey => !isEmpty(params[filterKey]))
}

export function countObjectToFilterItems(record: Record<string, { count: number }>): Array<App.FilterItem> {
  return Object.entries(record).map(([label, { count }]) => ({
    slug: slugify(label),
    label,
    count,
  }))
}

const PAYMENT_OPTION_LABELS: Record<string, string> = {
  pay_at_property: 'Pay at property',
}

export function mapPaymentOptionLabel(item: App.FilterItem): App.FilterItem {
  const label = PAYMENT_OPTION_LABELS[item.slug]
  return label ? { ...item, label } : item
}
